import {
  Show,
  SimpleShowLayout,
  TextField,
  BooleanField,
  NumberField,
  DateField,
  ArrayField,
  Datagrid,
  EditButton,
  TopToolbar,
} from 'react-admin';

const ContactGroupShowActions = () => (
  <TopToolbar>
    <EditButton />
  </TopToolbar>
);

export const ContactGroupShow = () => (
  <Show actions={<ContactGroupShowActions />}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <BooleanField source="isActive" />
      <NumberField source="sortOrder" />
      <DateField source="createdAt" showTime />
      <DateField source="updatedAt" showTime />
      
      <ArrayField source="contacts" label="Контакты в этой группе">
        <Datagrid>
          <TextField source="name" label="Название" />
          <TextField source="phone" label="Телефон" />
          <TextField source="email" label="Email" />
          <TextField source="address" label="Адрес" />
          <TextField source="workingHours" label="Часы работы" />
          <TextField source="mapLink" label="Ссылка на карту" />
          <BooleanField source="isActive" label="Активен" />
          <NumberField source="sortOrder" label="Порядок" />
        </Datagrid>
      </ArrayField>
    </SimpleShowLayout>
  </Show>
);
